import type { Difficulty } from "@hunch/core";

export interface TimeslipCategory {
  id: number;
  slug: string;
  name: { de: string; en: string };
}

export interface TimeslipCard {
  id: number;
  year: number;
  textDe: string;
  textEn: string;
  infoDe: string | null;
  infoEn: string | null;
  sourceLabel: string;
  sourceUrl: string;
}

export interface TimeslipPoolSize {
  count: number;
  threshold: number;
  enough: boolean;
}

export interface TimeslipNewGame {
  pointsPerCard: number;
  rounds: TimeslipCard[][];
}

function categoriesParam(categories: string[] | "all"): string {
  return categories === "all" ? "all" : categories.join(",");
}

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: "omit" });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Request failed (${res.status})`);
  }
  return (await res.json()) as T;
}

export function fetchTimeslipCategories(): Promise<TimeslipCategory[]> {
  return getJson("/api/public/timeslip/categories");
}

export function fetchTimeslipPoolSize(
  categories: string[] | "all",
  difficulty: Difficulty,
): Promise<TimeslipPoolSize> {
  const params = new URLSearchParams({ categories: categoriesParam(categories), difficulty });
  return getJson(`/api/public/timeslip/pool-size?${params.toString()}`);
}

export function fetchTimeslipNewGame(
  categories: string[] | "all",
  difficulty: Difficulty,
): Promise<TimeslipNewGame> {
  const params = new URLSearchParams({ categories: categoriesParam(categories), difficulty });
  return getJson(`/api/public/timeslip/new-game?${params.toString()}`);
}
